// src/components/ScrollRestoration.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Store the current scroll position before leaving
    const saveScrollPosition = () => {
      sessionStorage.setItem(
        `scrollPosition_${pathname}${search}`,
        JSON.stringify({
          x: window.scrollX,
          y: window.scrollY,
        })
      );
    };

    // Save position when leaving
    window.addEventListener('beforeunload', saveScrollPosition);

    // Force scroll to top on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant', // Use 'auto' if 'instant' doesn't work
    });

    // Also scroll the main elements
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    return () => {
      window.removeEventListener('beforeunload', saveScrollPosition);
    };
  }, [pathname, search]);

  return null;
}